export default "__VITE_ASSET__$vG3MfgZ__"